import React, { useState, useEffect } from 'react';
import './Prompt.css';

const Prompt = ({ isOpen, onClose, onSubmit, title, placeholder, confirmText, hasInput = true, danger= false, cancelText = "Annuller", hasLanguageSelector = false, languageOptions = [] }) => {
    const [inputValue, setInputValue] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState('');

    useEffect(() => {
        if (isOpen && hasLanguageSelector && languageOptions.length > 0) {
            setSelectedLanguage(languageOptions[0]);
        }
    }, [isOpen, hasLanguageSelector, languageOptions]);

    if (!isOpen) {
        return null; // Don't render the modal if isOpen is false
    }

    const handleConfirm = () => {
        if (hasLanguageSelector) {
            onSubmit(selectedLanguage);
            return;
        }

        const numericValue = parseInt(inputValue, 10);
        if (!isNaN(numericValue)) {
            onSubmit(numericValue);
            setInputValue(""); // Clear input after submission
        } else {
            onSubmit();
        }
    };

    return (
        <div className="prompt-overlay">
            <div className="prompt">
                <h3 className="prompt-title">{title}</h3>
                {hasInput && (
                    <input
                        type="number"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder={placeholder}
                        className="prompt-input no-spinner"
                    />
                )}
                {hasLanguageSelector && (
                    <select
                        value={selectedLanguage}
                        onChange={(e) => setSelectedLanguage(e.target.value)}
                        className="prompt-input"
                    >
                        {languageOptions.map((lang) => (
                            <option key={lang} value={lang}>
                                {lang.charAt(0).toUpperCase() + lang.slice(1)}
                            </option>
                        ))}
                    </select>
                )}
                <div className="prompt-buttons">
                    <button className={`prompt-button confirm ${danger ? 'danger' : ''}`} onClick={handleConfirm}>{confirmText}</button>
                    <button className="prompt-button cancel" onClick={onClose}>{cancelText}</button>
                </div>
            </div>
        </div>
    );
};

export default Prompt;